<template>
  <div class="login">
    <b-jumbotron :header="$t('system.login')">
      <b-form @submit="login">
        <div class="pull-left logincont">
          <label for="username">{{ $t('system.username') }}</label>
          <input id="username" class="form-control" v-model="username" autofocus type="text"/>
          <label for="password">{{ $t('system.password') }}</label>
          <input id="password" class="form-control" v-model="password" type="password"/><br/>
          <button class="btn btn-outline-primary pull-right" type="submit"><i
              class="fa fa-sign-in" aria-hidden="true"> </i> {{ $t('system.login') }}
          </button>
          <br/>
          <b-link to="/account/forgot">{{ $t('system.forgot_pw') }}</b-link>
        </div>
      </b-form>
    </b-jumbotron>
  </div>
</template>

<script>
import LoginService from '@/api-services/login.service'
import router from '@/router'
import {EventBus} from '@/eventbus'
import DormService from '@/api-services/dorm.service'

export default {
  name: 'sw_ka_login',
  data() {
    return {
      username: '',
      password: '',
      prevRoute: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  methods: {
    login: async function (ev) {
      ev.preventDefault()
      let self = this
      try {
        let response = await LoginService.login(this.username, this.password)
        self.$store.commit('login', response.data)
        if (self.$store.state.user != null) {
          let resp = await DormService.getMyDorm()
          self.$store.commit('set_dorm', resp.data.dorm)
        }
        if (self.prevRoute.path == "/login" || self.prevRoute.path.startsWith("/account/reset_pw/")) {
          await router.push("/account")
        } else {
          await router.push(self.prevRoute.path)
        }
      } catch (e) {
        EventBus.$emit('alert', {variant: 'danger', message: this.$t("errors.invalid_login")})
      }
    }
  }
}
</script>
